import { render } from "./multiselect.vue?vue&type=template&id=54475eed&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"

import "./multiselect.vue?vue&type=style&index=0&id=54475eed&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54475eed"]])

export default __exports__